import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import wavingHappily from 'assets/images/characters/CarolinaMariadeJesus/waving-happily.webp';
import {useEffect} from 'react';
import {connect} from 'react-redux';
import {getCompositionById} from 'store/reducers/compositions';
import {getLearningPath} from 'store/reducers/learningPath';
import {ApplicationState} from 'store/rootReducer';
import {timerSetup} from 'utils/functions/timer';
import useTrackEvent from 'utils/hooks/useTrackEvent';
import {CompositionDetailExtended} from 'utils/types/compositions';
import {LearningPathTemp} from 'utils/types/learningPath';
import Chat from '../../Chat';
import styles from './GeneralReview.module.scss';

interface StateProps {
  composition: ImmutableMap<CompositionDetailExtended>;
  learningPath?: LearningPathTemp;
}
export interface OwnProps {
  reviewMessageList: string[];
  studentScore: number | string;
  maxScore: number | string;
}

export type GeneralReviewProps = OwnProps & StateProps;

function GeneralReview({
  reviewMessageList,
  studentScore,
  maxScore,
  composition,
  learningPath,
}: GeneralReviewProps): JSX.Element {
  const {trackEvent} = useTrackEvent();

  useEffect(() => {
    const gradeTimer = timerSetup();

    return () => {
      trackEvent('multigenre_time_spent_in_general_review', {
        test: {
          test_id: composition.get('test_id'),
        },
        composition: {
          composition_id: Number(composition.get('id')),
        },
        review: {
          review_id: Number(
            composition.get('reviews')?.first()?.get('id') ?? 0,
          ),
        },
        learningPathInstance: {
          learning_path_instance_id: learningPath?.id ?? 0,
          learning_path_status: learningPath?.status ?? '',
        },
        time: {
          spent_time: gradeTimer.finish(),
        },
      });
    };
  }, []);

  function sendSawReviewEvent() {
    trackEvent('multigenre_seen_general_review', {
      test: {
        test_id: composition?.get('test_id'),
      },
      composition: {
        composition_id: Number(composition?.get('id')),
      },
      review: {
        review_id: Number(
          composition?.get('reviews')?.first()?.get('id') ?? null,
        ),
      },
      learningPathInstance: {
        learning_path_instance_id: learningPath?.id ?? 0,
        learning_path_status: learningPath?.status ?? '',
      },
      learningPathUserInstance: {
        learning_path_user_instance_id: Number(
          composition?.get('learning_path_user_instance_id'),
        ),
        step_id: composition?.getIn(['step', 'id']) ?? 0,
      },
    });
  }

  return (
    <section className={styles.wrapper}>
      <article className={styles.scoreCard}>
        <figure data-testid="score-image">
          <FontAwesomeIcon icon="bullseye-arrow" size="3x" />
        </figure>
        <h2>{`${studentScore} de ${maxScore}`}</h2>
        <p>Essa é sua nota, mas aprender é bem mais importante que ela!</p>
      </article>

      <Chat
        messageList={reviewMessageList}
        imageUrl={wavingHappily}
        stacked
        onChatEnd={sendSawReviewEvent}
      />
    </section>
  );
}

export default connect((state: ApplicationState) => ({
  composition: getCompositionById(state),
  learningPath: getLearningPath(state),
}))(GeneralReview);
